export function VendorInvoiceAcquisitionCtrl (
  $scope,
  $timeout,
  $translate,
  $uibModalInstance,
  bodyTypes,
  confirm,
  currencyApi,
  domainParserApi,
  driveTypes,
  franchises,
  fuelTypes,
  sessionObjAPI,
  templates,
  transmissionTypes,
  vehicleApi,
  workshopAPI
) {

  $scope.bodyTypes         = bodyTypes;
  $scope.company           = sessionObjAPI.company();
  $scope.currency          = currencyApi.getInfo();
  $scope.driveTypes        = driveTypes;
  $scope.flipped           = false;
  $scope.franchises        = franchises;
  $scope.fuelTypes         = fuelTypes;
  $scope.index             = 0;
  $scope.quantity          = 1;
  $scope.quantityUpdated   = false;
  $scope.rangeMax          = 10;
  $scope.rangeMin          = 1;
  $scope.regoLabel         = $scope.company.company_variable_fields.plate_number_name || sessionObjAPI.countrySettings().rego_label;
  $scope.templates         = templates;
  $scope.transmissionTypes = transmissionTypes;
  $scope.selectedItems     = [];

  $scope.IE = domainParserApi.isInternetExplorer();

  $scope.acquisitions = [
    {
      active: true,
      title : 1,
      unit  : { is_new: true },
      onSelect () {
        $scope.index = this.title - 1;

        angular.forEach($scope.acquisitions, acquisition => {
          acquisition.active = false;
        });

        this.active = true;
      }
    }
  ];

  $scope.tableSettings = {
    columns: [
      {
        classes: 'text-left',
        field  : 'find_description',
        header : {
          text: $translate.instant('GENERAL_SPACE.FIELD.REFERENCE')
        }
      },
      {
        classes: 'text-left',
        field  : 'make',
        header : {
          text: $translate.instant('VEHICLE_SPACE.MAKE')
        }
      },
      {
        classes: 'text-left',
        field  : 'model',
        header : {
          text: $translate.instant('VEHICLE_SPACE.MODEL')
        }
      },
      {
        classes: 'text-left',
        field  : 'group_or_franchise_name',
        header : {
          text: $translate.instant('COMPANY_SPACE.FRANCHISE.GROUP_FRANCHISE')
        }
      },
      {
        classes: 'text-left',
        field  : 'body_type',
        header : {
          text: $translate.instant('VEHICLE_SPACE.BODY_TYPE')
        }
      }
    ],
    empty: {
      text: $translate.instant('INSPECTIONS_SPACE.TEMPLATES.NO_TEMPLATES_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : 10,
      pageSizes : [ 5, 10 ],
      queryCount: () => workshopAPI.get('/vehicle_templates/count')
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true
      }
    },
    sorting: {
      direction: 'asc',
      enabled  : true,
      field    : 'find_description'
    },
  };

  $scope.onRowClick = function () {
    $scope.selectedItems = $scope.templates.filter(row => row.selected);
  };

  $scope.onRowDoubleClick = function (event) {
    $scope.selectedItems = [event.row];
    $scope.selectTemplate();
  };

  $scope.flipModal = function () {
    $scope.flipped = !$scope.flipped;

    $scope.$emit('flipModal');
  };

  $scope.getTemplates = ( params ) => {
    return workshopAPI.get('/vehicle_templates', [
      params.offset,
      params.pageSize,
      params.field,
      params.direction,
    ]).then(templates => {
      $scope.templates = templates;
      if (!templates.length && !$scope.flipped) {
        $scope.flipModal();
      }
      return templates;
    });
  };

  $scope.nextRange = function () {
    $scope.rangeMax += 10;
    $scope.rangeMin += 10;
  };

  $scope.persistGSTFree = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.UPDATING_TAX_FREE_WILL_AFFECT_ACQUISITION', { tax: $scope.currency.tax_name }))
    .then(() => {
      angular.forEach($scope.acquisitions, acquisition => {
        acquisition.unit.gst_free = $scope.acquisitions[$scope.index].unit.gst_free;
      });
    })
    .catch(() => {
      $scope.acquisitions[$scope.index].unit.gst_free = !$scope.acquisitions[$scope.index].unit.gst_free;
    });
  };

  // Sets all acquisition's unit data
  // to the currently selected unit.
  $scope.persistUnits = function () {
    angular.forEach($scope.acquisitions, acquisition => {
      acquisition.unit = angular.extend({}, acquisition.unit, $scope.acquisitions[$scope.index].unit);
    });
  };

  $scope.prevRange = function () {
    $scope.rangeMax -= 10;
    $scope.rangeMin -= 10;
  };

  // Checks whether the quantity was increased
  // or decreased and adds/removes acquisitions as
  // necessary. If acquisitions are added, their unit
  // object is inherited from the current active unit.
  $scope.refreshQuantity = function () {
    var difference;

    if ($scope.quantity > $scope.acquisitions.length) {
      difference = $scope.quantity - $scope.acquisitions.length;

      for (var i = 0; i < difference; i++) {
        $scope.acquisitions.push({
          active: false,
          title : $scope.acquisitions[$scope.acquisitions.length - 1].title + 1,
          unit  : angular.extend({}, $scope.acquisitions[$scope.index].unit),
          onSelect () {
            $scope.index = this.title - 1;

            angular.forEach($scope.acquisitions, acquisition =>{
              acquisition.active = false;
            });

            this.active = true;
          }
        });
      }
    }
    else if ($scope.quantity < $scope.acquisitions.length) {
      difference = $scope.acquisitions.length - $scope.quantity;

      // If the active tab is part of what is being removed,
      // set the first tab to active.
      if ($scope.index >= ($scope.acquisitions.length - difference)) {
        $scope.index = 0;

        $timeout(() => $scope.acquisitions[0].onSelect());
      }

      $scope.acquisitions.splice($scope.acquisitions.length - difference, $scope.acquisitions.length - 1);

      // If the current range was removed, set it
      // to the beginning of acquisitions.
      if ($scope.rangeMin > $scope.acquisitions.length) {
        $scope.rangeMax = 10;
        $scope.rangeMin = 1;
      }
    }

    $scope.quantityUpdated = false;
  };

  $scope.refreshValue = function () {
    confirm.notify({ message: $translate.instant('JS_SPACE.MESSAGES.UPDATED.ALL_ACQUISITIONS') })
    .then(() => {
      angular.forEach($scope.acquisitions, acquisition => {
        acquisition.unit.value_of_acquisition               = $scope.acquisitions[$scope.index].unit.value_of_acquisition;
        acquisition.unit.value_of_acquisition_including_tax = $scope.acquisitions[$scope.index].unit.value_of_acquisition_including_tax;
      });
    });
  };

  $scope.save = function () {
    $uibModalInstance.close($scope.acquisitions);
  };

  $scope.selectTemplate = function () {
    $scope.acquisitions[0].unit        = $scope.selectedItems[0];
    $scope.acquisitions[0].unit.is_new = true;

    $scope.flipModal();
  };

  $scope.setQuantityUpdated = function () {
    $scope.quantityUpdated = true;
  };

  // user updated the vehicle suggested sale
  // price including tax, so update the price
  // excluding tax.
  $scope.updatePriceExcludingTax = function () {
    $scope.acquisitions[$scope.index].unit.suggested_sale_price =
      vehicleApi.calculatePriceExcludingTax($scope.acquisitions[$scope.index].unit.suggested_sale_price_including_tax);
  };

  // user updated the vehicle suggested sale
  // price excluding tax, so update the price
  // including tax.
  $scope.updatePriceIncludingTax = function () {
    $scope.acquisitions[$scope.index].unit.suggested_sale_price_including_tax =
      vehicleApi.calculatePriceIncludingTax($scope.acquisitions[$scope.index].unit.suggested_sale_price);
  };

  // user updated the value of acquisition
  // including tax, so update the value
  // excluding tax.
  $scope.updateValueExcludingTax = function () {
    $scope.acquisitions[$scope.index].unit.value_of_acquisition =
      vehicleApi.calculatePriceExcludingTax($scope.acquisitions[$scope.index].unit.value_of_acquisition_including_tax);
  };

  // user updated the value of acquisition
  // excluding tax, so update the value
  // including tax.
  $scope.updateValueIncludingTax = function () {
    $scope.acquisitions[$scope.index].unit.value_of_acquisition_including_tax =
      vehicleApi.calculatePriceIncludingTax($scope.acquisitions[$scope.index].unit.value_of_acquisition);
  };

  $scope.getTemplates({ offset: 0, pageSize: 10, field: 'find_description', direction: 'asc' });
}